import { Directive , HostListener } from '@angular/core';

@Directive({
	selector: '[appNoEnterKey]'
})
export class NoEnterKeyDirective {

	@HostListener('keydown', ['$event'])
	onKeyDown(event: KeyboardEvent) {
		if (event.key === 'Enter' || (event as any).keyCode === 13) {
			event.preventDefault();
			event.stopPropagation();
		}
	}
}
